import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { setCookie,removeCookie } from "typescript-cookie";
import { CasConfig, CasContextType, User } from './types';
import { redirectToCasLogin, validateTicket } from './casUtils';
import AccountService from '../services/AccountService';
import { LoggedUser, SetLoggedUser } from '../types/Usuario/LoggedUser';
import { useDispatch } from 'react-redux';
import { inUser, outUser } from '../redux/slices/auth.slice';

export const CasContext = createContext<CasContextType | undefined>(undefined);

export const CasProvider: React.FC<{ config: CasConfig, children: React.ReactNode }> = ({ config, children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [authUser, setAuthUser] = useState<LoggedUser | null>(null);
  const hasRun = useRef(false);
  const dispatch = useDispatch();

  const login = () => {
    redirectToCasLogin(config.casServer, config.service);
  };

  const logout = () => {
    const logoutUrl = `${config.casServer}/logout?service=${encodeURIComponent(config.service)}`;
    dispatch(outUser());
    removeCookie('token');
    setUser(null);
    window.location.href = logoutUrl;
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ticket = params.get("ticket");

    if (!hasRun.current && ticket) {
      validateTicket(config.casServer, config.service, ticket).then((user) => {
        if (user) {
          setUser(user);
          console.log("Usuario autenticado:", user.username);
          AccountService.Login(user.username)
              .then((userData) => {
                  console.log(userData)
                  dispatch(inUser({
                      userData: {
                          usuario: user.username,
                          token: userData.token,
                          expiration: userData.expiration
                      },
                      rol:"",
                      token: userData.token,
                      isAuth: true,
                      isLoading: false
                  })); // Guarda en Redux
                  setCookie("token", userData.token)  
                  // Elimina el ticket de la URL (sin recargar la p�gina)
                  const cleanUrl = window.location.origin + window.location.pathname;
                  window.history.replaceState({}, document.title, cleanUrl);

                  // Redirige al m�dulo admin despu�s de limpiar la URL
                  const modulo = "admin";
                  const newUrl = `${window.location.origin}/${modulo}`;
                  console.log("Redirigiendo a: " + newUrl);
                  window.location.href = newUrl; // Redirige al m�dulo
              })
            .catch((error) => {
              console.error("Error fetching user data from backend:", error);
            });
          // Elimina el ticket de la URL
            //const modulo = 'admin';
            //const newUrl = window.location.origin + window.location.pathname+modulo;
            //console.log("newurl:"+newUrl)
            //window.history.replaceState({}, document.title, newUrl);
            //window.location.href = newUrl;
            //window.location.reload();
            //window.location.replace(newUrl)
        }
      });
      hasRun.current = true;
    }
  }, [config]);

  return (
    <CasContext.Provider value={{ user, isAuthenticated: !!user, login, logout }}>
      {children}
    </CasContext.Provider>
  );
};

export const useCas = (): CasContextType => {
  const context = useContext(CasContext);
  if (!context) {
    throw new Error('useCas must be used within a CasProvider');
  }
  return context;
};
